import React from 'react'

import { Box, Grid, Step } from '@mui/material'
import { GridStepper } from '@front/squirtle'

import FormHeader from '@abra/elements/headers/Form'

import { TranslationSection, SettingSection } from './Section'

const Equipment = ({ isManagingRecord }) =>
  <Box sx={{ display: 'flex', justifyContent: 'center' }} px={6}>
    <Grid container rowSpacing={3}>
      <Grid size={12}><FormHeader goBackPath={'/equipment'} /></Grid>
      <Grid size={12}>
        <GridStepper groupsCount={[4]} activeStep={0} orientation="vertical">
          <Step> <TranslationSection /></Step>
          <Step> <SettingSection /> </Step>
        </GridStepper>
      </Grid>
    </Grid>
  </Box>

export default React.memo(Equipment)
